import styled, { css } from 'styled-components';
import { ADigitSize, type ADigitProps } from './ADigit.types';
import { baseVariables } from '../../styles';

const { spacers } = baseVariables;

type StyleProps = Omit<ADigitProps, 'text'>;

const extraLargeStyles = css`
  padding-block-end: ${spacers?.spacers?.[2]};
  font-size: 5.625rem;
`;

const largeStyles = css`
  padding-block-end: ${spacers?.spacers?.[1]};
  font-size: 1.875rem;
`;

const mediumStyles = css`
  font-size: 1.375rem;
`;

const smallStyles = css`
  font-size: 1rem;
`;

const extraSmallStyles = css`
  font-size: 0.875rem;
`;

const stylesBySize = ({ size = ADigitSize.S }: StyleProps) => {
  return {
    [ADigitSize.XL]: extraLargeStyles,
    [ADigitSize.L]: largeStyles,
    [ADigitSize.M]: mediumStyles,
    [ADigitSize.S]: smallStyles,
    [ADigitSize.XS]: extraSmallStyles,
    [ADigitSize.ExtraLarge]: extraLargeStyles,
    [ADigitSize.Large]: largeStyles,
    [ADigitSize.Medium]: mediumStyles,
    [ADigitSize.Small]: smallStyles,
    [ADigitSize.ExtraSmall]: extraSmallStyles,
  }[size];
};

export const ADigitWrapper = styled.span<StyleProps>`
  color: var(--t-brand-fg-color);
  font-family: var(--t-font-family);
  font-weight: 700;
  line-height: 1;
  display: inline-block;
  ${stylesBySize}
`;
